export const STUDENT_REPORT_HEADERS_KEYS = [
  {
    headerName: "First Name",
    keyName: "first_name",
    typeof: "string",
  },
  {
    headerName: "Last Name",
    keyName: "last_name",
    typeof: "string",
  },
  { headerName: "User Name", keyName: "username", typeof: "string" },
  {
    headerName: "Email Address",
    keyName: "email_address",
    typeof: "string",
  },
  {
    headerName: "Mobile Number",
    keyName: "mobile_number",
    typeof: "string",
  },
  {
    headerName: "Department Name",
    keyName: "department",
    typeof: "object",
    value: "name",
  },
  { headerName: "Course", keyName: "course", typeof: "object", value: "name" },
  { headerName: "Batch", keyName: "batch", typeof: "object", value: "batch" },
  {
    headerName: "Enrollment No",
    keyName: "enrollment_no",
    typeof: "string",
  },
  { headerName: "Section", keyName: "section", typeof: "string" },
  {
    headerName: "Expiry Date",
    keyName: "expiry_date",
    typeof: "string",
  },
  {
    headerName: "Roles",
    keyName: "userByRole",
    typeof: "array",
    value: "role",
  },
  {
    headerName: "LoggedIn At",
    keyName: "user_login_log",
    typeof: "array",
    value: "login_at"
  },
  {
    headerName: "Status",
    keyName: "is_active",
    typeof: "boolean",
    value: ["Active", "InActive"],
  },
];
